import React from "react";
import Forbidden from "../pages/Forbidden";
import ForgotPassword from "../pages/ForgotPassword";
import InternalServerError from "../pages/InternalServerError";
import NotFound from "../pages/NotFound";
import ServiceUnavailable from "../pages/ServiceUnavailable";
import Signin2 from "../pages/Signin2";
import VerifyAccount from "../pages/VerifyAccount";
import Logout from "../pages/Logout";
import ShipmentTrackingPreview from "../pages/dev/ShipmentTrackingPreview";
import OrderDetailPreview from "../pages/dev/OrderDetailPreview";
import ShipmentOrdersPreview from "../pages/dev/ShipmentOrdersPreview";

const publicRoutes = [
  { path: "login", element: <Signin2 /> },
  { path: "logout", element: <Logout /> },
  { path: "verify", element: <VerifyAccount /> },
  { path: "pages/forgot", element: <ForgotPassword /> },
  { path: "pages/error-404", element: <NotFound /> },
  { path: "pages/error-500", element: <InternalServerError /> },
  { path: "pages/error-503", element: <ServiceUnavailable /> },
  { path: "pages/error-505", element: <Forbidden /> }
];

if (process.env.REACT_APP_ENABLE_SHIPMENT_PREVIEW === 'true') {
  publicRoutes.push({
    path: 'preview/shipment-tracking',
    element: <ShipmentTrackingPreview />,
  });
}

if (process.env.REACT_APP_ENABLE_ORDER_DETAIL_PREVIEW === 'true') {
  publicRoutes.push({
    path: 'preview/order-detail',
    element: <OrderDetailPreview />,
  });
}

if (process.env.REACT_APP_ENABLE_SHIPMENT_ORDERS_PREVIEW === 'true') {
  publicRoutes.push({
    path: 'preview/shipment-orders',
    element: <ShipmentOrdersPreview />,
  });
}

export default publicRoutes;